import { createContext, useContext, useState, ReactNode } from 'react';

interface SidebarContextType {
  isCollapsed: boolean;
  setIsCollapsed: (collapsed: boolean) => void;
  isMobileMenuOpen: boolean;
  setIsMobileMenuOpen: (open: boolean) => void;
  getContentMargin: () => string;
  getResponsiveContentMargin: () => string;
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined);

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const getContentMargin = () => {
    return isCollapsed ? 'lg:ml-16' : 'lg:ml-56';
  };

  const getResponsiveContentMargin = () => {
    return isCollapsed ? 'lg:ml-16 xl:ml-20' : 'lg:ml-56 xl:ml-64';
  };

  return (
    <SidebarContext.Provider value={{
      isCollapsed,
      setIsCollapsed,
      isMobileMenuOpen,
      setIsMobileMenuOpen,
      getContentMargin,
      getResponsiveContentMargin
    }}>
      {children}
    </SidebarContext.Provider>
  );
}

export function useSidebar() {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider');
  }
  return context;
}